module.exports = __webpack_public_path__ + "static/media/redoImg.b9f88f79.svg";